/** @deprecated - KRs are now created AFTER a goal is created */
export default {
	title: "Key result {number}",
	nameFieldLabel: "KR name",
	nameFieldPlaceholder: "e.g. Sell 100,000 widgets",
	confidenceLevelFieldLabel: "Confidence",
	confidenceLevelFieldHint: "Your level of confidence that this key result will be completed on time.",
	typeFieldLabel: "KR type",
	typeFieldHint: "Choose from numeric, currency, percentage, or binary.",
	binaryFieldLabel: "Status",
	currentValueFieldLabel: "Current value",
	targetValueFieldLabel: "Target value",
	startDateFieldLabel: "Start date",
	endDateFieldLabel: "End (target) date",
	ownerIdFieldLabel: "Owner",
	ownerIdFieldHint: "The person responsible for this result.",
	parentGoalFieldLabel: "Parent Goal",
};
